/* Built In Imports */
/* External Imports */
import { Box } from '@chakra-ui/react';
import { nanoid } from 'nanoid';

/* Internal Imports */
/* Component */
/* Services  */
/* Styles */
import SectionUI from '@components/UI/Common/SectionUI';

/**
 * Renders Expression Component
 * @param {Object} sectionContent - data for the section from api
 * @param {string} region - Region of the section
 * @param {string} lang - Language of the section
 */
const ContactUs = ({ sectionContent, lang, region }) => {
  return (
    <Box w="full">
      <Box
        width={'100%'}
        height="auto"
        display="flex"
        flexDir="column"
        alignItems="center"
        justifyContent="center"
        pb="50px"
        textAlign="center"
        px={{
          xl: 'calc((100% - 1112px) / 2)',
          lg: '18px',
          md: '18px',
          sm: '18px',
          base: '18px',
        }}
      >
        {sectionContent && sectionContent.length
          ? sectionContent.map(section => {
              return (
                <SectionUI
                  key={nanoid(4)}
                  sectionContent={section}
                  region={region}
                  language={lang}
                />
              );
            })
          : null}
      </Box>
    </Box>
  );
};

export default ContactUs;
